export default function PageSkeleton({ withHero = false }) {
  const SKELETON_ROWS = 3;
  const CARDS_PER_ROW = 8; // Enough to overflow screen so it looks like a row

  return (
    <div className="w-full min-h-screen bg-dark-900 pb-16">
      {/* Hero Skeleton */}
      {withHero && (
        <div className="w-full aspect-square md:aspect-[21/9] lg:h-[80vh] bg-dark-800 animate-pulse relative">
          <div className="absolute bottom-1/4 left-10 w-1/3 space-y-4">
            <div className="h-10 bg-dark-700 rounded-lg w-3/4"></div>
            <div className="h-4 bg-dark-700 rounded w-full"></div>
            <div className="h-4 bg-dark-700 rounded w-5/6"></div>
            <div className="flex gap-4 pt-4">
              <div className="w-32 h-12 bg-dark-700 rounded-full"></div>
              <div className="w-32 h-12 bg-dark-700 rounded-full"></div>
            </div>
          </div>
        </div>
      )}
      
      {/* Content Rows Skeleton */}
      <div className={`pt-8 ${!withHero ? 'pt-24' : ''}`}>
        {[...Array(SKELETON_ROWS)].map((_, rIndex) => (
          <div key={rIndex} className="mb-10">
            {/* Header */}
            <div className="px-5 md:px-10 mb-4 flex justify-between items-center">
              <div className="w-48 h-6 bg-dark-700 rounded-md animate-pulse"></div>
            </div>
            
            {/* Cards */}
            <div className="flex gap-3 md:gap-4 overflow-hidden px-5 md:px-10">
              {[...Array(CARDS_PER_ROW)].map((_, cIndex) => (
                <div 
                  key={cIndex} 
                  className="flex-shrink-0 w-[160px] sm:w-[180px] md:w-[200px]"
                >
                  <div className="w-full aspect-[2/3] bg-dark-800 rounded-xl animate-pulse"></div>
                  <div className="w-3/4 h-4 bg-dark-700 rounded mt-3 animate-pulse"></div>
                  <div className="w-1/2 h-3 bg-dark-700 rounded mt-2 animate-pulse"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
